export enum MenuHamburger {
  MENU = 'isHamburgerMenuOpen',
  BUTTON = 'isHamburgerButtonSelected',
}

export enum MenuHamburgerValue {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}
